export const orderCardSteps = {
    chooseAccount: 'velg-konto',
    keepPinDecision: 'behold-pin',
    choosePin: 'velg-pin',
    summary: 'oppsummering',
};
